<template>
    <b-modal id="edit_webhook_modal" @ok="editWebhook" size="l" no-close-on-backdrop>
        <template slot="modal-title">Edit the webhoook</template>
        <form ref="edit_webhook_form">
            <b-form-group
                    label="Name"
                    label-for="name">
                <b-form-input
                        id="name"
                        v-model="selected_webhook.name"
                        :state="validateName"
                        autofocus
                        required/>
                <b-form-invalid-feedback :state="validateName">
                    Name is invalid, it needs at least {{minNameLength}}
                    characters.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Event"
                    label-for="event">
                <b-form-select
                        id="event"
                        :state="validateEvent"
                        v-model="selected_webhook.event_name"
                        :options="event_options"
                        required/>
                <b-form-invalid-feedback :state="validateEvent">
                    Select an event.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Active"
                    label-for="active">
                <b-form-checkbox
                        id="active"
                        v-model="selected_webhook.active"
                        required/>
            </b-form-group>
            <b-form-group
                    label="path"
                    label-for="path">
                <b-form-input
                        id="path"
                        v-model="selected_webhook.path"
                        :state="validatePath"
                        required/>
                <b-form-invalid-feedback :state="validatePath">
                    Select an event.
                </b-form-invalid-feedback>
                <hr>
                <b-form-group
                        label="Or generate a random path for the url:"
                        label-for="pathLength">
                    <b-form-input
                            id="pathLength"
                            type="range"
                            min="5"
                            max="100"
                            v-model="pathLength"
                            oninput="amount.value=this.pathLength"/>
                    <b-btn class="btn btn-primary" v-on:click="generateRandomPath">Generate a: {{this.pathLength}}
                        character random path
                    </b-btn>
                </b-form-group>
            </b-form-group>
            <b-form-group
                    label="Notes and description (optional)"
                    label-for="notes">
                <b-form-textarea
                        id="notes"
                        v-model="selected_webhook.notes_and_description"/>
            </b-form-group>
        </form>
    </b-modal>
</template>

<script>
    import WebhookRepository from '../../repositories/webhook.repository';

    export default {
        props: {
            selected_webhook: {
                type: Object,
                default: WebhookRepository.blankWebhook
            },
            event_options: {
                type: Array,
                default: () => []
            },
            pathLength: {
                type: Number,
                default: parseInt(process.env.VUE_APP_WEBHOOK_DEFAULT_PATH_LENGTH)
            },
        },
        data() {
            return {minNameLength: process.env.VUE_APP_VALIDATION_WEBHOOK_MIN_NAME_LENGTH}
        },
        methods: {
            generateRandomPath() {
                this.selected_webhook.path = WebhookRepository.generateRandomPath(this.pathLength);
            },
            checkFields() {
                if (WebhookRepository.validate.name(this.selected_webhook.name) === false) return false;
                if (WebhookRepository.validate.project(this.selected_webhook.project_id) === false) return false;
                if (WebhookRepository.validate.event(this.selected_webhook.event_name) === false) return false;
                if (WebhookRepository.validate.path(this.selected_webhook.path) === false) return false;
                return true;
            },
            editWebhook(modal) {
                if (this.$refs.edit_webhook_form.checkValidity() && this.checkFields()) {
                    this.$emit('show-loading-pop-up', 'Saving the changes to the selected webhook.');
                    WebhookRepository.put(this.selected_webhook.id, this.selected_webhook).then(res => {
                        // Emit the webhook edited event
                        this.$emit('reset-loading-pop-up');
                        this.$emit('webhook-edited', res.data);
                        // Notify the user.
                        this.$bvToast.toast(`Webhook ${res.data.name} successfully edited.`, {
                            title: `Webhook edited.`,
                            variant: 'success',
                            solid: true
                        });
                    }).catch(error => {
                        this.$emit('reset-loading-pop-up');
                        this.$bvModal.show('edit_webhook_modal');
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the webhook. Check the value\'s of all the fields', {
                                title: `Webhook validation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else if (error.response.status === 409) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while creating the webhook. Pls. check if the path of the url unique is in the project scope.', {
                                title: `Webhook unique error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while editing the webhook.', {
                                title: `Webhook edit error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validateProject() {
                return WebhookRepository.validate.project(this.selected_webhook.project_id);
            },
            validateEvent() {
                return WebhookRepository.validate.event(this.selected_webhook.event_name);
            },
            validateName() {
                return WebhookRepository.validate.name(this.selected_webhook.name);
            },
            validatePath() {
                return WebhookRepository.validate.path(this.selected_webhook.path);
            },
        }
    }
</script>
